import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreguntaService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  guardar(pregunta) {
    return this.http.post(this.apiUrl + "pregunta/guardarPregunta", pregunta);
  }

  actualizar(pregunta) {
    return this.http.put(this.apiUrl + "pregunta/actualizarPregunta", pregunta);
  }

  obtenerTodasPorIdVotacion(idVotacion: number) {
    return this.http.get(this.apiUrl + "pregunta/obtenerBoleta?idVotacion=" + idVotacion);
  }

  obtenerPagina(page: number, size: number, idVotacion: number) {
    return this.http.get(this.apiUrl + "pregunta/obtenerPreguntas?page=" + page + "&size=" + size + "&idVotacion=" + idVotacion);
  }

  obtenerPaginaLink(link) {
    return this.http.get(link);
  }

  obtenerPorId(idPregunta: number) {
    return this.http.get(this.apiUrl + "pregunta/consultaPregunta?idPregunta=" + idPregunta);
  }

  eliminarPorId(idPregunta: number) {
    return this.http.delete(this.apiUrl + "pregunta/eliminarPregunta?idPregunta=" + idPregunta);
  }

}
